"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getDefaultParams_1 = require("../helpers/getDefaultParams");
var ky_imlpConfig_1 = require("../config/ky.imlpConfig");
var service_status_enum_1 = require("../enums/service-status.enum");
var LinkService = {
    createAttempt: function (studentId, attemptRequestBody) {
        var params = (0, getDefaultParams_1.getDefaultParams)();
        return (0, ky_imlpConfig_1.post)("".concat(params.fixedformUrl, "/students/").concat(studentId, "/attempts"), {
            json: attemptRequestBody
        })
            .then(function (response) { return response.json(); })
            .then(function (response) { return formatLinkResponse(service_status_enum_1.default.LOADED, response); })
            .catch(function (error) { return formatLinkResponse(service_status_enum_1.default.ERROR, error); });
    },
    attemptStatus: function (studentId, attemptId) {
        var params = (0, getDefaultParams_1.getDefaultParams)();
        return fetch("".concat(params.fixedformUrl, "/students/").concat(studentId, "/attempts/").concat(attemptId), {
            method: "GET",
            headers: {
                Authorization: "Bearer ".concat(params.imlpToken)
            }
        })
            .then(function (response) {
            if (!response.ok) {
                throw new Error("Error: ".concat(response.statusText));
            }
            return response.json();
        })
            .then(function (response) { return formatLinkResponse(service_status_enum_1.default.LOADED, response); })
            .catch(function (error) { return formatLinkResponse(service_status_enum_1.default.ERROR, error); });
    }
};
exports.default = LinkService;
var formatLinkResponse = function (status, response) { return ({
    status: status,
    response: response
}); };
